import React from "react";
import useElementTilt from "../../hooks/useElementTilt";
import useScrollReveal from "../../hooks/useScrollReveal";

/**
 * <TiltCard> — a card wrapper that combines scroll-reveal entrance with
 * cursor-tracked 3D tilt + spotlight on hover. Used for benefit cards.
 *
 * Mirrors the <Reveal> prop API (variant, delay, className, as) so it's a
 * drop-in upgrade anywhere you want the tilt/spotlight polish.
 */
export default function TiltCard({
  as: Tag = "div",
  variant = "scale-rot",
  delay = 0,
  className = "",
  strength = 0.6,
  threshold = 0.15,
  children,
  ...rest
}) {
  const [revealRef, revealed] = useScrollReveal({ threshold });
  const tiltRef = useElementTilt({ strength });

  // Compose both refs on the same element.
  const setRef = (node) => {
    revealRef.current = node;
    tiltRef.current = node;
  };

  const style = delay ? { transitionDelay: `${delay}ms` } : undefined;

  return (
    <Tag
      ref={setRef}
      className={className}
      data-reveal=""
      data-variant={variant}
      data-revealed={revealed ? "true" : "false"}
      data-tilt=""
      style={style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
